import { render, staticRenderFns } from "./ScrollComponent.vue?vue&type=template&id=4ccca0c7&scoped=true"
import script from "./ScrollComponent.vue?vue&type=script&lang=js"
export * from "./ScrollComponent.vue?vue&type=script&lang=js"
import style0 from "./ScrollComponent.vue?vue&type=style&index=0&id=4ccca0c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccca0c7",
  null
  
)

export default component.exports